import * as Sentry from "@sentry/browser";
/* global ga */
import env from '../env';
import { uuidv4 } from "./random";

/* eslint-disable */
// @ts-ignore
window.ga = window.ga || function () {
  (ga.q = ga.q || []).push(arguments)
};
ga.l = +new Date;
/* eslint-enable */

export function init(): void {
  const $script = document.createElement('script') as HTMLScriptElement;
  $script.async = true;
  $script.src = 'https://www.google-analytics.com/analytics.js';
  $script.onabort = () => {
    Sentry.addBreadcrumb({
      category: 'analytics',
      message: `Aborted loading ${$script.src}`,
      level: Sentry.Severity.Warning,
    });
  };
  $script.onerror = () => {
    Sentry.addBreadcrumb({
      category: 'analytics',
      message: `Failed to load ${$script.src}`,
      level: Sentry.Severity.Warning,
    });
  };

  document.head.appendChild($script);

  ga('create', env.gaId, {
    cookieFlags: 'SameSite=None; Secure',
  });
}

export function pageview(path: string, pagetitle?: string): void {
  const title = pagetitle || path || document.title;

  ga('send', {
    hitType: 'pageview',
    location: `${env.feUrl}/${path}?reqId=${uuidv4()}`,
    title,
  });
}

export function event(category: string, action: string, label: string, value?: number, options?: any): void {
  ga('send', 'event', category, action, label, value, options);
}

export function identify(userId: string): void {
  ga('set', 'userId', userId);
}
